module.exports = __webpack_public_path__ + "assets/77e49a760cc8a06f2daeccfd7d4aa258.png";